import { useState } from "react"
import { Text, Button } from "@mobi/ds"
import isClient from "@mobi/utils/browser/isClient"
import "./featureToggle.scss"

const STORAGE_KEY = "@feature-toggle"

const setup = ({ definitions, features } = {}) => {
  if (isClient()) {
    const defaultState = JSON.parse(localStorage.getItem(STORAGE_KEY))
    const flags = Object.keys(features).reduce((acc, featureName) => {
      const state = features[featureName].some((def) => {
        return definitions[def]
      })

      acc[featureName] = state
      return acc
    }, {})

    localStorage.setItem(
      STORAGE_KEY,
      JSON.stringify({
        features,
        flags: defaultState?.flags || flags,
        definitions,
      })
    )
  }
}

const get = (name) => {
  if (isClient()) {
    const storage = localStorage.getItem(STORAGE_KEY)
    const flags = storage ? JSON.parse(storage)?.flags : null
    const flag = flags[name]

    return flag
  }
}

const set = (name, value) => {
  if (isClient()) {
    const storage = JSON.parse(localStorage.getItem(STORAGE_KEY))
    let flags = storage?.flags
    flags[name] = value
    localStorage.setItem(STORAGE_KEY, JSON.stringify({ ...storage, flags }))
  }
}

const UI = () => {
  const storage = isClient() && JSON.parse(localStorage.getItem(STORAGE_KEY))
  const features = storage?.features
  const flags = storage?.flags
  const [toggle, setToggle] = useState(false)

  const onClickOption = (featureName) => {
    set(featureName, !flags[featureName])
    window.location.reload()
  }

  return (
    <div className={`ds-feature ${toggle ? "ds-feature--active" : ""}`}>
      <Button variant="secondary" onClick={() => setToggle(!toggle)} fluid>
        Feature Toggle
        {toggle ? " -" : " +"}
      </Button>

      <ul className="ds-feature__items">
        {features &&
          Object.keys(features).map((featureName) => (
            <li key={featureName}>
              <div className="ds-feature__definitions">
                <Text as="span" size="xs" weight={700}>
                  actived:{" "}
                </Text>
                <Text as="span" size="xs">
                  {features[featureName].join(" | ")}
                </Text>
              </div>
              <Text
                as="label"
                size={"xl"}
                weight={700}
                className="ds-feature__label"
              >
                <input
                  onClick={() => onClickOption(featureName)}
                  type="checkbox"
                  checked={flags[featureName]}
                  id={featureName}
                  name={featureName}
                />
                {featureName}
              </Text>
            </li>
          ))}
      </ul>
    </div>
  )
}

export default {
  setup,
  get,
  UI,
}
